import { ark } from "@ark-ui/react/factory"
import type { ComponentProps } from "react"
import { styled } from "styled-system/jsx"

const CardRoot = styled(ark.div, {
  base: {
    backgroundColor: "surface",
    padding: "md",
    borderRadius: "md",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    position: "relative",
    border: true,
    // A card made `inert` (non-interactive) dims itself.
    "&[inert]": {
      opacity: "muted",
    },
  },
  variants: {
    variant: {
      filled: {
        backgroundColor: "secondary",
        color: "text",
      },
    },
    magicBox: {
      true: {
        borderColor: "[transparent]",

        _before: {
          content: '""',
          position: "absolute",
          inset: "[0]",
          pointerEvents: "none",
          borderRadius: "[inherit]",
          background:
            "[linear-gradient(180deg, rgba(255,55,91,0.5) 0%, rgba(255,153,3,0.5) 49.48%, rgba(51,196,179,0.5) 100%)]",
          mask: "linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)",
          maskComposite: "exclude",
          WebkitMask:
            "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
          WebkitMaskComposite: "xor",
          padding: "[2px]",
        },
      },
    },
  },
  defaultVariants: {
    magicBox: false,
  },
})

const CardHeader = styled(ark.div)
const CardBody = styled(ark.div, {
  base: {
    display: "flex",
    flex: "1",
    flexDirection: "column",
  },
})
const CardFooter = styled(ark.div, {
  base: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "md",
  },
})
const CardTitle = styled(ark.h3, {
  base: {
    textStyle: "heading",
  },
})
const CardDescription = styled(ark.p)

export type CardRootProps = ComponentProps<typeof CardRoot>
export type CardHeaderProps = ComponentProps<typeof CardHeader>
export type CardBodyProps = ComponentProps<typeof CardBody>
export type CardFooterProps = ComponentProps<typeof CardFooter>
export type CardTitleProps = ComponentProps<typeof CardTitle>
export type CardDescriptionProps = ComponentProps<typeof CardDescription>

export const Card = {
  Root: CardRoot,
  Header: CardHeader,
  Body: CardBody,
  Footer: CardFooter,
  Title: CardTitle,
  Description: CardDescription,
} as const
